// Copyright 2025, University of Maryland, All Rights Reserved
import type { FC } from 'react'
import type { NodeAdminViewProps } from '../../../../core/types'
import {
  DatasourceConfigSection,
  type AnalysisResultsDatasourceSettings,
} from '@/subsystems/datasources'

export const RedlineAdminView: FC<NodeAdminViewProps> = ({
  config,
  onChange,
  orgId,
  workspaceId,
}) => {
  const datasourceConfig = config?.datasourceConfig as
    | AnalysisResultsDatasourceSettings
    | undefined

  const handleDatasourceConfigChange = (key: string, value: unknown) => {
    onChange?.('datasourceConfig', {
      ...(datasourceConfig ?? {}),
      [key]: value,
    })
  }

  return (
    <div className="space-y-4">
      <DatasourceConfigSection
        datasourceType="analysis_results"
        onDatasourceTypeChange={() => {}}
        datasourceConfig={datasourceConfig}
        onConfigChange={handleDatasourceConfigChange}
        allowedTypes={['analysis_results']}
        orgId={orgId}
        workspaceId={workspaceId}
        title="Findings Source"
        description="Upstream analysis datasets whose findings drive the highlights"
      />
    </div>
  )
}
